import React, { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import '../Assets/Css/CustomCalendar.css';
import { getDateRange } from '../Lib/utils';

const CustomCalendar = ({ inData, setFilteredData, selectedStatus, searchTerm, applyFilters, startDate, endDate, setStartDate, setEndDate, project }) => {
    const [filter, setFilter] = useState('');
    const [calendarOpen, setCalendarOpen] = useState(false);
    const modalRef = useRef(null);
    const inputRef = useRef(null);

    const handleFilterChange = (selectedFilter) => {
        setFilter(selectedFilter);
        const { startDate: newStartDate, endDate: newEndDate } = getDateRange(selectedFilter);
        setStartDate(newStartDate);
        setEndDate(newEndDate);
    };

    const filterData = () => {
        if (!startDate) return;

        const effectiveEndDate = endDate || startDate;

        applyFilters({
            status: selectedStatus,
            search: searchTerm,
            startDate,
            endDate: effectiveEndDate,
            project: project
        });
    };

    const handleApply = () => {
        if (startDate && endDate) {
            filterData();
        } else {
            console.log('Please select a valid date range.');
        }
        setCalendarOpen(false);
    };

    const handleCancel = () => {
        setStartDate(null);
        setEndDate(null);
        setFilter('');
        setFilteredData && setFilteredData(inData);
        setCalendarOpen(false);
    };

    const handleInputClick = () => {
        setCalendarOpen(!calendarOpen);
    };


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                modalRef.current && !modalRef.current.contains(event.target) &&
                inputRef.current && !inputRef.current.contains(event.target)
            ) {
                setCalendarOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="custom-calendar-container">
            <input
                ref={inputRef}
                type="text"
                placeholder="Date"
                className="date-input"
                onClick={handleInputClick}
                value={
                    startDate && endDate
                        ? `${moment(startDate).format('MMM D, YYYY')} - ${moment(endDate).format('MMM D, YYYY')}`
                        : ''
                }
                readOnly
            />
            {calendarOpen && (
                <div className="calendar-container" ref={modalRef}>
                    <div className="calendar-filters">
                        <ul>
                            {['Today', 'Yesterday', 'Last 7 Days', 'Last 14 Days', 'Last 30 Days', 'Last 3 Months', 'Last 12 Months', 'Custom'].map((option) => (
                                <li key={option} className={filter === option ? 'active' : ''} onClick={() => handleFilterChange(option)}>
                                    {option}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="calendar-display">
                        <DatePicker
                            selected={startDate}
                            onChange={(dates) => {
                                const [start, end] = dates;
                                setStartDate(start);
                                setEndDate(end);

                                if (start && end) {
                                    setFilter('Custom');
                                }
                            }}
                            startDate={startDate}
                            endDate={endDate}
                            inline
                            selectsRange
                            maxDate={null}
                        />
                        <div className="calendar-buttons">
                            <button className="cancel-btn" onClick={handleCancel}>Cancel</button>
                            <button className="apply-btn" onClick={handleApply}>Apply</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CustomCalendar;